var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPushPinRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.416 10.17l-7.587-7.584a2 2 0 00-2.829 0L12.297 9.31c-1.333-.418-4.375-.921-7.55 1.642a2 2 0 00-.162 2.973l6.04 6.037-5.332 5.33a1 1 0 101.415 1.414l5.329-5.332 6.036 6.036a1.998 1.998 0 001.415.589h.141a1.991 1.991 0 001.455-.792c2.455-3.262 2.219-5.915 1.649-7.5L29.417 13a2 2 0 00-.002-2.83zM28 11.587l-7.158 7.182a1.001 1.001 0 00-.186 1.153c1.182 2.366-.226 4.824-1.168 6.077L6 12.51c1.51-1.218 2.955-1.54 4.06-1.54a5.017 5.017 0 012.042.405 1 1 0 001.156-.19L20.416 4 28 11.585z"
  })));
}
export default SvgPushPinRegular;